import {
  BigPlayButton,
  MaximizeMinimizeFullscreen,
  MuteUnmute,
  PlayPause,
} from "./controlButtons"
import VolumeControl from "./VolumeControl"

export {
  BigPlayButton,
  MaximizeMinimizeFullscreen,
  MuteUnmute,
  PlayPause,
  VolumeControl,
}
